import { render, staticRenderFns } from "./Evaluation-attempts-pagination.vue?vue&type=template&id=27da8a3e"
import script from "./Evaluation-attempts-pagination.vue?vue&type=script&lang=js"
export * from "./Evaluation-attempts-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports